import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export interface IProject {
  id: number;
  name: string;
  startDate: Date;
  endDate: Date;
  description: string;
  activityList: IActivity[];
  localityList: any[];
  administrator: any;
  devise: Devise;
}

interface Devise {
  id: number;
  name: string;
  code: string;
}

interface IActivity {
  id: number;
  name: string;
  subActivityList: ISubActivity[] | null;
}

interface ISubActivity {
  id: number;
  name: string;
  productionList: IProduction[] | null;
}

interface IProduction {
  id: number;
  name: string;
}

export const useProject = () => {
  const [project, setProject] = useState<IProject | null>(null);
  const httpClient = useHttpClient();
  const params: any = useParams();

  useEffect(() => {
    const fetchProject = async () => {
      const reposnse = await httpClient.current?.get(`/api/project/${params?.id}`);
      const data = reposnse?.data;
      setProject(data);
    };
    fetchProject();
  }, [httpClient, params?.id]);

  return { project };
};
